module.exports = __webpack_public_path__ + "static/media/rci_suite_bedroom-790x592.83b0ffc6.jpg";